import React from 'react';
import {connect} from 'react-redux';
import {BaseFilterComponent} from 'components/organisms/used-players-list/components/filter/game-types/classic';

class FilterComponent extends BaseFilterComponent {
    render() {
        const {sportConfig} = this.props;

        if (!sportConfig.usePositionFilter()) {
            return false;
        }

        return <div className="tabs-chk-fixed">{this.prepareTabs()}</div>;
    }
}

function mapStatesToProps(state) {
    return {
        sportConfig: state.sportConfig,
        filters: state.usedPlayers.filters,
    };
}

const Filter = connect(mapStatesToProps)(FilterComponent);

export {Filter};
